export const AUTH_TOKEN = '__alnpiz'
export const AUTH_NOMOR_PENDAFTARAN = 'auth_nomor_pendaftaran'
export const AUTH_NAMA_PENGGUNA = 'auth_nama_pengguna'
export const AUTH_MASUKAN = 'auth_masukan'
export const FOTO_CMHS = 'auth_foto'

export const AUTH_USERNAME = 'auth_username'
